import Vue from 'vue';

const layer = Vue.directive('layer', {
    inserted: function(el: Element, binding: any) {
        el.setAttribute('id', binding.value)
        el.setAttribute('class', el.className + ' layer-display')
    }
})

export default layer;